import { Component, input } from '@angular/core';
import { FieldTree, FormField } from '@angular/forms/signals';
import { MatInputModule } from '@angular/material/input';
import { SpacingComponent } from '../spacing/spacing.component';
import { Grouping } from './grouping.model';


@Component({
  selector: 'app-grouping',
  imports: [FormField, MatInputModule, SpacingComponent],
  templateUrl: './grouping.component.html',
  styles: ``,
})
export class GroupingComponent {

  readonly form = input.required<FieldTree<Grouping>>();

  ngOnDestroy() {

    if (!this.form().parallelCables().valid())
      this.form().parallelCables().value.set(0);

    if (!this.form().numberOfCircuits().valid())
      this.form().numberOfCircuits().value.set(0);

  }


}
